export function ResourceCardLayout({
  loading,
  message = "No contents to display",
  children,
  total,
  className
}) {
  return (
    <div className={`row mt-lg-4 gy-4 ${className}`}>
      {loading ? "Loading ..." : total ? children : message}
    </div>
  );
}
